import { RouteConfig } from 'vue-router'

const routes: Array<RouteConfig> = [
    {
        path: '/partner-tools/rtbf',
        component: () => import('@/views/PartnerTools/RTBF.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: false,
        }
    },
]

export default routes;